import type { DomainError } from './DomainError';

export type Result<Value, ErrorType extends DomainError = DomainError> =
  { readonly ok: true; readonly value: Value } | { readonly ok: false; readonly error: ErrorType };

export function success<Value, ErrorType extends DomainError = DomainError>(
  value: Value,
): Result<Value, ErrorType> {
  return { ok: true, value };
}

export function failure<ErrorType extends DomainError>(error: ErrorType): Result<never, ErrorType> {
  return { ok: false, error };
}
